<div class="notfound__wrapper">
  <h2>There seems to be a problem</h2>

  <p>
    Looks like you haven't been granted permission to access this resource or the URL is invalid.
  </p>

  <xi-default-button
    text="Back to Homepage"
    fill="outline"
    contrast="high"
    (onClick)="onHomepageClicked()"
  ></xi-default-button>
</div>
